import { Injectable, OnDestroy } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TabService implements OnDestroy {
  private heartbeatId?: number; //Latido que mantiene la pestaña actual activa
  private checkId?: number; //Latido que revisa si otra pestaña está activa
  private handler?: (e: StorageEvent) => void; //Referencia al storage
  private events$ = new Subject<'open' | 'close'>();

  watchSamePage(pageKey: string = 'epione.dohealth.com.mx'): Observable<'open' | 'close'> {
    const currentUrl = window.location.href; //URL completo de la pestaña

    // Revisar el estado de las pestañas cada 5 segunndos
    this.heartbeatId = window.setInterval(() => {
      localStorage.setItem(pageKey, JSON.stringify({ url: currentUrl, time: Date.now() }));
    }, 1000);

    let lastOtherTabTime = 0;
    let otherTabActive = false;

    // Buscar latidos de otras pestañas
    this.handler = (e: StorageEvent) => {
      if (e.key === pageKey && e.newValue) { //El storage detecta que hay un nuevo valor de una pestaña abierta
        const { url, time } = JSON.parse(e.newValue);
        if (url === currentUrl) { //Si el URL de esta pestaña es el mismo
          lastOtherTabTime = time;
          if (!otherTabActive) {
            otherTabActive = true;
            this.events$.next('open'); //Si es la primera vez que encontramos esa pestaña, abrimos
          }
        }
      }
    };
    window.addEventListener('storage', this.handler);

    // Checar periodicamente si la otra pestaña dejó de mandar latidos
    this.checkId = window.setInterval(() => {
      if (otherTabActive && Date.now() - lastOtherTabTime > 2000) {
        otherTabActive = false;
        this.events$.next('close');
      }
    }, 1000);

    return this.events$.asObservable();
  }

  stopWatching(): void {
    if (this.heartbeatId) {
      clearInterval(this.heartbeatId);
      this.heartbeatId = undefined;
    }
    if (this.checkId) {
      clearInterval(this.checkId);
      this.checkId = undefined;
    }
    if (this.handler) {
      window.removeEventListener('storage', this.handler);
      this.handler = undefined;
    }
  }

  ngOnDestroy(): void {
    this.stopWatching();
  }
}
